<template>
  <div class="main-content" style="min-height: 766px">
    <section class="section">
      <div class="section-header">
        <h1>Manage Contest</h1>
      </div>

      <!-- Modal -->
      <b-modal id="modal-1" title="Contest Form" @ok="handleOk">
        <div class="alert alert-danger">
          Make sure to input date in UTC time
        </div>
        <div class="form-group">
          <label class="control-label">Title</label>
          <input
            type="text"
            class="form-control"
            v-model.lazy="contest.title"
            placeholder="eg New Year Contest"
          />
        </div>

        <div class="form-group">
          <label class="control-label">Date Start</label>
          <input
            type="datetime-local"
            class="form-control"
            v-model.lazy="contest.date_start"
          />
        </div>

        <div class="form-group">
          <label class="control-label">Date End</label>
          <input
            type="datetime-local"
            class="form-control"
            v-model.lazy="contest.date_end"
          />
        </div>
      </b-modal>

      <b-modal id="modal-2" title="Previous Winners" @ok="handleOkWinners">
        <div class="form-group" v-for="(row, key) in winners" :key="key">
          <div class="row">
            <div class="col-sm-8">
              <label class="control-label">Winner {{ key + 1 }}</label>
              <input
                type="number"
                class="form-control"
                v-model.lazy="row.login"
                placeholder="account number here"
              />
            </div>
            <div class="col-sm-4">
              <label class="control-label">Total gain</label>
              <input
                type="number"
                class="form-control"
                v-model.lazy="row.gain"
                placeholder="Total gain here"
              />
            </div>
          </div>
        </div>
      </b-modal>

      <!-- Modal Participants -->
      <b-modal id="modal-3" title="Participants" @ok="handleOk" size="lg">
        <b-table
          class="tb-exposure"
          :sticky-header="true"
          :no-border-collapse="true"
          :filter="filter"
          striped
          hover
          bordered
          responsive
          :busy.sync="isBusy"
          :items="participants"
          :fields="participant_fields"
          :sort-by.sync="sortBy"
        >
          <template v-slot:cell(action)="data">
            <b-button
              variant="warning"
              @click="handleEditParticipant(data.index)"
            >
              <font-awesome-icon icon="edit" color="white" />
            </b-button>
          </template>
        </b-table>
      </b-modal>

      <!-- Modal Edit Participants -->
      <b-modal
        id="modal-4"
        title="Edit Participant"
        @ok="handleUpdateParticipant"
      >
        <div class="form-group">
          <label class="control-label">Rank</label>
          <input
            type="number"
            class="form-control"
            v-model.lazy="participantEdit.rank"
            placeholder="eg New Year Contest"
          />
        </div>

        <div class="form-group">
          <label class="control-label">Gain</label>
          <input
            type="text"
            class="form-control"
            v-model.lazy="participantEdit.gain"
            placeholder="eg New Year Contest"
          />
        </div>
      </b-modal>

      <div class="section-body">
        <div class="card">
          <div class="card-header">
            <h4>Contest List Table</h4>
            <div class="card-header-action">
              <button class="btn btn-sm btn-danger mr-2" v-b-modal.modal-2>
                Prev Winners
              </button>
              <button class="btn btn-sm btn-primary" v-b-modal.modal-1>
                New Contest
              </button>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-sm-4 mb-2">
                <b-input-group size="sm">
                  <b-form-input
                    v-model="filter"
                    type="search"
                    id="filterInput"
                    placeholder="Type to Search"
                  ></b-form-input>
                </b-input-group>
              </div>
            </div>
            <p class="small">There are {{ items.length }} Contest</p>
            <b-table
              class="tb-exposure"
              :sticky-header="true"
              :no-border-collapse="true"
              :filter="filter"
              striped
              hover
              bordered
              responsive
              :busy.sync="isBusy"
              :items="items"
              :fields="fields"
            >
              <template v-slot:cell(action)="data">
                <b-button
                  variant="warning"
                  class="mx-1"
                  @click="handleUpdate(data.item)"
                >
                  <font-awesome-icon icon="edit" color="white" />
                </b-button>

                <b-button
                  variant="danger"
                  class="mx-1"
                  @click="deleteSuppression(data.item.id)"
                >
                  <font-awesome-icon icon="trash" color="white" />
                </b-button>

                <b-button
                  variant="info"
                  @click="handleShowParticipants(data.item.id)"
                >
                  <font-awesome-icon icon="user" color="white" />
                </b-button>

                <b-button
                  variant="success"
                  class="mx-1"
                  @click="handleDownload(data.item.id)"
                >
                  <font-awesome-icon icon="download" color="white" />
                </b-button>
              </template>
            </b-table>
          </div>
          <div class="card-footer bg-whitesmoke"></div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { createContest, getContest, deleteContest, updateContest, updateWinners, getWinners, getParticipants, updateParticipant, downloadParticipants } from "@/api/contest";
export default {
  data() {
    return {
      sortBy: 'rank',
      fields: [
        { key: "title", sortable: true, label: 'Title' },
        { key: "date_start", sortable: true, label: 'Date Start' },
        { key: "date_end", sortable: true, label: 'Date End' },
        { key: "action", sortable: false, label: 'Action' },
      ],
      contest: {
        id: null,
        title: null,
        date_start: null,
        date_end: null
      },
      isBusy: false,
      items: [],
      filter: null,
      account: "",
      winners: [
        {
          login: null,
          gain: 0
        },
        {
          login: null,
          gain: 0
        },
        {
          login: null,
          gain: 0
        }
      ],
      participants: [],
      participant_fields: [
        { key: "rank", sortable: true, label: 'Rank' },
        { key: "login", sortable: true, label: 'Login' },
        { key: "name", sortable: true, label: 'Name' },
        { key: "country", sortable: true, label: 'Country' },
        { key: "gain", sortable: true, label: 'Gain' },
        { key: "action", sortable: false, label: 'Action' },
      ],
      participantEdit: {
        rank: 0,
        gain: 0
      }
    };
  },
  computed: {
    rows() {
      return this.items.length;
    }
  },
  mounted() {
    this.fetchData();

    getWinners().then(response => {
      this.winners = response.data
    })
  },
  beforeDestroy() {

  },
  destroyed() { },
  methods: {
    handleOk() {
      if (this.contest.id) {
        updateContest(this.contest.id, this.contest).then(() => {
          this.fetchData()
          this.$bvToast.toast(`Success updating record`, {
            title: 'Success',
            variant: 'primary',
            autoHideDelay: 5000
          })

          this.account = ''
        }).catch(() => {
          this.$bvToast.toast(`Failed while updating record`, {
            title: 'Failed',
            variant: 'danger',
            autoHideDelay: 5000
          })
          this.account = ''
        })
      } else {
        createContest(this.contest).then(() => {
          this.fetchData()
          this.$bvToast.toast(`Success adding record`, {
            title: 'Success',
            variant: 'primary',
            autoHideDelay: 5000
          })

          this.account = ''
        }).catch(() => {
          this.$bvToast.toast(`Failed while inserting record`, {
            title: 'Failed',
            variant: 'danger',
            autoHideDelay: 5000
          })
          this.account = ''
        })
      }

    },

    handleOkWinners() {
      updateWinners({
        winners: this.winners
      })
        .then(() => {
          this.$bvToast.toast(`Success adding record`, {
            title: 'Success',
            variant: 'primary',
            autoHideDelay: 5000
          })
        })

    },
    fetchData() {
      getContest()
        .then(data => {
          this.items = data.data;
        })
        .catch(() => []);
    },
    deleteSuppression(login) {
      this.boxTwo = ''
      this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this record.', {
        title: 'Please Confirm',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then(value => {
          // Delete action
          if (value) {
            deleteContest(login).then(() => {
              this.fetchData()
              this.$bvToast.toast(`Success delete record`, {
                title: 'Success',
                variant: 'primary',
                autoHideDelay: 5000
              })
            }).catch(() => {
              this.$bvToast.toast(`Failed while deleting record`, {
                title: 'Failed',
                variant: 'danger',
                autoHideDelay: 5000
              })
            })
          }
        })
        .catch(err => {
          // An error occurred

        })
    },
    handleUpdate(item) {
      this.contest = item
      this.$bvModal.show("modal-1")
    },

    handleShowParticipants(id) {
      getParticipants(id).then(response => {
        this.participants = response.data;
        this.$bvModal.show("modal-3")
      });

    },
    handleEditParticipant(key) {
      this.participantEdit = this.participants[key];

      this.$bvModal.show("modal-4")
    },
    handleUpdateParticipant() {
      updateParticipant(this.participantEdit).then(() => {
        // Update Modal
        this.$bvToast.toast(`Success updating record`, {
          title: 'Success',
          variant: 'primary',
          autoHideDelay: 5000
        })
      })
    },
    handleDownload(id) {
      downloadParticipants(id).then(response => {
        const url = URL.createObjectURL(new Blob([response.data], {
          type: 'text/csv'
        }))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', "contest_participants.csv")
        document.body.appendChild(link)
        link.click()
      });
    }
  }
};
</script>

<style scoped>
.tb-exposure {
  max-height: 500px;
}
</style>
